import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useFilterContext } from "../head-bar/filter-context";
import { CheckIcon } from "../../icons";
import { observer } from "mobx-react-lite";

export const Cuisines = observer(({ classNames }) => {
  const { state, setState, filterParams } = useFilterContext();
  const { t } = useTranslation();
  const rightRef = React.useRef(null);

  const toggle = (id, key) => {
    setState((prev) => {
      const list = prev[key] || [];
      let newList = [];
      if (list.includes(id)) {
        newList = list.filter((locId) => locId !== id);
      } else {
        newList = [...list, id];
      }
      return { [key]: newList };
    });
  };

  const [currentCategory, setCurrentCategory] = useState(null);

  const categories = useMemo(() => {
    return filterParams.cuisines_categories.filter((item) => {
      return item.cuisines && item.cuisines.length > 0;
    });
  }, [filterParams.cuisines_categories]);

  const cuisines = useMemo(() => {
    return (
      categories.find((item) => {
        return item.id === currentCategory;
      })?.cuisines || []
    );
  }, [categories, currentCategory]);

  // 自动选中第一个分类
  useEffect(() => {
    if (categories.length > 0 && !currentCategory) {
      setCurrentCategory(categories[0].id);
    }
  }, [categories, currentCategory]);

  useEffect(() => {
    rightRef.current && rightRef.current.scrollTo(0, 0);
  }, [currentCategory]);

  const isActive = (id) => {
    return state["cuisines.id"] && state["cuisines.id"].includes(id);
  };

  return (
    <div className={cn("head-filter-group", classNames)}>
      <div className="head-filter-title">{t("Browse.cuisines")}</div>
      <div className="head-filter-cuisines">
        <div className="head-filter-cuisines-left">
          {categories.map((item) => {
            return (
              <div
                className={cn("cuisines-left-item", {
                  "is-active": currentCategory === item.id,
                })}
                key={item.id}
                onClick={() => setCurrentCategory(item.id)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <div className="head-filter-cuisines-right" ref={rightRef}>
          {cuisines.map((item) => {
            return (
              <div
                className={cn("cuisines-right-item", {
                  "is-active": isActive(item.id),
                })}
                key={item.id}
                onClick={() => toggle(item.id, "cuisines.id")}
              >
                <span>{item.name}</span>
                {isActive(item.id) && <CheckIcon></CheckIcon>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
